import { Modal, ModalContent, ModalHeader, ModalRoot, Select } from '@pella/sash-framework';
import { useAPI } from '@pella/cosmos-react';
import { ebsInstances } from '../../../data/appConfig';

/**
 * Developer Tools Modal Component
 * Provides a modal for developers to manage EBS instance settings.
 * @param {object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {() => void} props.onClose - Callback function when modal is closed
 * @returns {import("react").ReactElement} Developer tools modal component
 */
const DevTools = ({ isOpen, onClose }) => {
  const { setSelectedEBSInstance, selectedEBSInstance } = useAPI();

  const handleInstanceChange = (e) => {
    setSelectedEBSInstance(e.target.value);
  };

  return (
    // @ts-ignore
    <ModalRoot open={isOpen} onOpenChange={onClose}>
      <Modal data-testid={`devtools-modal-open:${isOpen}`}>
        <ModalHeader>Developer Tools</ModalHeader>
        <ModalContent>
          <Select
            id='ebs-instance-select'
            labelText='Select EBS Instance'
            onChange={handleInstanceChange}
            value={selectedEBSInstance}
            data-testid='ebs-instance-select'
          >
            {ebsInstances.map(({ instanceID, name }) => (
              <option key={instanceID} value={instanceID}>
                {name}
              </option>
            ))}
          </Select>
        </ModalContent>
      </Modal>
    </ModalRoot>
  );
};

export default DevTools;
